import { useMutation } from '@tanstack/react-query';
import { zohoClient } from 'src/lib/api';

export const useBusiness = () => {
  const mutationFn = (payload) =>
    zohoClient
      .post('api/v1/whatsapp/sendCompanyRequestToZoho', payload)
      .then((response) => response?.data);
  return useMutation({
    mutationFn,
  });
};
